import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NonNullableFormBuilder } from '@angular/forms';
import { CustomerApi } from '@api/index';
import { IdName } from '@api/models/idname';
import { Subject, takeUntil } from 'rxjs';
import { CustomerParams } from '../model/customer.model';
import { removeEmptyValues } from '@app/shared/utils/remove-empty-values.utils';

@Component({
  selector: 'flow-customer-filter-section',
  templateUrl: './customer-filter-section.component.html',
  styleUrls: ['./customer-filter-section.component.scss'],
})
export class CustomerFilterSectionComponent implements OnInit, OnDestroy {
  protected destroy$ = new Subject<void>();
  @Output() onFilter = new EventEmitter();

  formGroup = this.fb.group({
    text: '',
    customerIds: [],
  });
  customerOptions: IdName[];

  constructor(private customerService: CustomerApi, private fb: NonNullableFormBuilder) {}

  ngOnInit(): void {
    this.getCustomerOptions();
  }

  getCustomerOptions(): void {
    this.customerService
      .getCustomerOptions()
      .pipe(takeUntil(this.destroy$))
      .subscribe((customerOptions: IdName[]) => {
        this.customerOptions = customerOptions;
      });
  }

  submit(): void {
    if (this.formGroup.pristine) {
      return;
    }

    this.emitParams();
  }

  clearAll(): void {
    this.formGroup.reset({
      text: '',
      customerIds: [],
    });

    this.emitParams();
  }

  emitParams() {
    const cleanedFormValues: CustomerParams = removeEmptyValues(this.formGroup.value);
    this.onFilter.emit(cleanedFormValues);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
